export const ROUTE_TYPE_REDIRECT = 'redirect';
